import React from 'react'
import { useDomainMessages } from 'domains/account-management/utils/domain/intl'
import { NewSelect, type SimpleOption } from '@retailer-platform/shared-components'
import { AccountStatusEnum } from 'domains/account-management/api'

interface Props {
  onChange: (v: string | undefined) => void
  value: AccountStatusEnum | undefined
}

export const AccountManagementSimpleStatusSelect: React.FunctionComponent<Props> = ({
  value,
  onChange,
}) => {
  const i18n = useDomainMessages({
    placeholder: 'accountManagementDomain.roles.status.placeholder',
    accountStatusActivated: 'accountManagementDomain.list.statuses.activated',
    accountStatusDeactivated: 'accountManagementDomain.list.statuses.deactivated',
    accountStatusPendingSetup: 'accountManagementDomain.list.statuses.pendingSetup',
  })

  const accountStatusOptions: SimpleOption<AccountStatusEnum>[] = [
    { label: i18n.accountStatusActivated, value: AccountStatusEnum.Active },
    { label: i18n.accountStatusDeactivated, value: AccountStatusEnum.Disabled },
    { label: i18n.accountStatusPendingSetup, value: AccountStatusEnum.Pending },
  ]

  return (
    <NewSelect
      placeholder={i18n.placeholder}
      options={accountStatusOptions}
      value={value}
      onChange={value => onChange(value)}
      isClearable
    />
  )
}
